const FIELDS = [
  'manager',
  'pay_rate'
];

export default FIELDS;
